<template>
  <v-subheader :inset="false" :style="`color: ${color}; ${componentStyle}`" class="px-0 subheader" :class="{'subheader__small': small}">{{formattedText}}</v-subheader>
</template>

<script>
export default {
  name: "SubHeader",
  props:{
    text: {
      type: String,
      required: true
    },
    small:{
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: '#666666'
    },
    componentStyle: {
      type: String,
      default: 'line-height: 16.1px!important;'
    }
  },
  computed:{
    formattedText(){
      return String(this.text).toUpperCase();
    }
  }
};
</script>

<style lang="scss" scoped>
.subheader{
  font-size: 14px!important;
  font-weight: 700!important;
  font-family: Arial, sans-serif!important;
  &__small{
    font-size: 12px!important;
  }
}
</style>
